import React, { FC } from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'

import { theme } from '@elamajs/ui-kit'

import IndexFormInner from '../IndexFormInner/IndexFormInner'

import * as Styled from './IndexForm.styled'

type Props = {
  renderPlace: string
  elementId: string
}

const IndexForm: FC<Props> = ({ renderPlace, elementId }) => {
  return (
    <Styled.Container>
      <Styled.InfoBlock>
        <Styled.Title className="text-light">
          Будьте в&nbsp;курсе изменений digital&#8209;рынка
        </Styled.Title>
        <Styled.Subtitle>
          Раз в&nbsp;квартал мы&nbsp;будем напоминать о&nbsp;выходе свежих данных DAAI
          и&nbsp;появлении новых исследований. Без спама, только цифры
        </Styled.Subtitle>
      </Styled.InfoBlock>
      <IndexFormInner renderPlace={renderPlace} elementId={elementId} />
    </Styled.Container>
  )
}

const withProviders = (Component: FC<Props>): FC<Props> => {
  const NewComponent: FC<Props> = props => {
    return (
      <ThemeProvider theme={theme}>
        <IntlProvider locale="ru">
          <Component {...props} />
        </IntlProvider>
      </ThemeProvider>
    )
  }

  return NewComponent
}

export default withProviders(IndexForm)
